class PostImageRetina {
  constructor(el) {
    this.el = el;
    if ($(this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const elementWrap = document.querySelector(this.el);
    const images = elementWrap.querySelectorAll('.wp-block-image');
    images.forEach((item) => {
      if (item.classList.contains('is-retina')) {
        const retinaImage = item.querySelector('img');
        if (retinaImage.hasAttribute('width')) {
          const itemWidth = parseInt(retinaImage.getAttribute('width'), 10); // width属性を数値として取得
          const styleWidth = (itemWidth / 2) + 'px'; // 幅を半分にし、rem単位を追加
          retinaImage.style.width = styleWidth;
        }
      }
    });
  }

}
